import { memo } from 'react'

import { CardStack } from '@/components/common/Card'
import { StatCombo } from '@/components/common/Stat'
import { type ComboPreviewType } from '@/defs/combo'
import { useLinkInternal } from '@/hooks/useLinkInternal'

import styles from './ComboPreview.module.scss'

type Props = {
  combo: ComboPreviewType
}

export const ComboPreviewInner = ({ combo }: Props) => {
  const { buildRelative } = useLinkInternal()

  const href = buildRelative({
    colorId: combo.colorId,
    comboSlug: combo.id,
    section: 'combosFeatured',
  })

  return (
    <div className={styles.container}>
      <div className={styles.info}>
        <ul className={styles.stats}>
          <li>
            <StatCombo combo={combo} stat='requirements' />
          </li>
          <li>
            <StatCombo combo={combo} stat='colorId' />
          </li>
          <li>
            <StatCombo combo={combo} stat='inclusion' />
          </li>
        </ul>
        <div className={styles.statResults}>
          <StatCombo combo={combo} stat='results' />
        </div>
        <div className={styles.statBrackets}>
          <StatCombo combo={combo} stat='brackets' />
        </div>
      </div>
      <div className={styles.cards}>
        <CardStack cards={combo.cards.slice().reverse()} href={href} />
      </div>
    </div>
  )
}

export const ComboPreview = memo(ComboPreviewInner)
